import { DoubleTouchBase, TouchData } from '../data';
import { ZEDCamera } from '../ZEDCamera';
import { checkPinchDoubleTouch, fovByPinch, getPinchSquaredDistance } from '../ZEDCameraInputHelper';
import { InputCanvasProps } from '../ZEDCameraInputManager';

let prevPinchSquaredDistance: number = 0;
export const DoubleTouchPinchFOV: DoubleTouchBase = {
  type: 'DoubleTouch',
  touchCount: 2,
  key: 'DoubleTouchPinch',
  name: 'DoubleTouchPinchZoomFOV',
  option: {},
  attachControl(
    _camera: ZEDCamera,
    _canvasProps: InputCanvasProps,
    _isMobileOrTablet: boolean,
    _noPreventDefault?: boolean | undefined
  ) {},
  detachControl(_camera: ZEDCamera, _isMobileOrTablet: boolean) {},
  checkInputs(_camera: ZEDCamera) {},
  reset() {},
  checkCondition(_camera: ZEDCamera, touchData: TouchData[]) {
    prevPinchSquaredDistance = getPinchSquaredDistance(touchData);
    return checkPinchDoubleTouch(touchData);
  },
  onTouchStart(_camera, _touchData, _canvasProps) {},
  onTouchMoved(camera: ZEDCamera, touchData: TouchData[], _canvasProps: InputCanvasProps) {
    const prevDistance = prevPinchSquaredDistance;
    const pinchSquaredDistance = getPinchSquaredDistance(touchData);
    prevPinchSquaredDistance = pinchSquaredDistance;

    fovByPinch(camera, pinchSquaredDistance - prevDistance, 1);
  },
  onTouchEnd(_camera: ZEDCamera, _touchData: TouchData[], _canvasProps: InputCanvasProps) {
    prevPinchSquaredDistance = 0;
  },
};
